import PropTypes from 'prop-types';
import React from 'react';
import { TASK_STATUS } from '../../../../../lib/schema.js';
import RadioOptionsField from '../../../../RadioOptionsField.jsx';

const options = TASK_STATUS.map((type) => ({
  label: type,
  value: type,
}));

TaskStatusField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

function TaskStatusField({ label, name }) {
  return (
    <RadioOptionsField
      id="status"
      label={label}
      name={name}
      options={options}
    />
  );
}

export default TaskStatusField;
